import * as Yup from 'yup';
import { STANDARD_FIELD_LIMIT } from '@poplar/constants/app';
import { Text } from '@yoweb/ui/components/typography';
import { Grid } from '@yoweb/ui/components/Grid';
import { I_DO_NOT_KNOW_ID } from '@poplar/constants/intake';
import { Textarea } from '@yoweb/ui/components/form';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var getTextInitialValues = function getTextInitialValues(textAnswer) {
  var _textAnswer$answeredV, _textAnswer$answeredV2;

  return (_textAnswer$answeredV = textAnswer === null || textAnswer === void 0 ? void 0 : (_textAnswer$answeredV2 = textAnswer.answeredValue) === null || _textAnswer$answeredV2 === void 0 ? void 0 : _textAnswer$answeredV2.value) !== null && _textAnswer$answeredV !== void 0 ? _textAnswer$answeredV : '';
};
export var getTextValidationSchema = function getTextValidationSchema(isOptional, t) {
  return Yup.string().trim().when(I_DO_NOT_KNOW_ID, {
    is: true,
    then: Yup.string(),
    otherwise: isOptional ? Yup.string() : Yup.string().required(t('validation.required', {
      ns: 'common'
    }))
  });
};
export var TextElement = function TextElement(_ref) {
  var _textAnswer$inputFiel, _textAnswer$maxLength, _textAnswer$maxLength2;

  var instructionHint = _ref.instructionHint,
      textAnswer = _ref.textAnswer,
      isDisabled = _ref.isDisabled,
      id = _ref.id;
  return /*#__PURE__*/_jsxs(Grid, {
    rowGap: "small2",
    children: [instructionHint && /*#__PURE__*/_jsx(Text, {
      size: "md",
      children: instructionHint
    }), /*#__PURE__*/_jsx(Textarea, {
      id: id,
      name: id,
      label: (_textAnswer$inputFiel = textAnswer === null || textAnswer === void 0 ? void 0 : textAnswer.inputFieldHint) !== null && _textAnswer$inputFiel !== void 0 ? _textAnswer$inputFiel : '',
      maxLength: (_textAnswer$maxLength = textAnswer === null || textAnswer === void 0 ? void 0 : (_textAnswer$maxLength2 = textAnswer.maxLength) === null || _textAnswer$maxLength2 === void 0 ? void 0 : _textAnswer$maxLength2.value) !== null && _textAnswer$maxLength !== void 0 ? _textAnswer$maxLength : STANDARD_FIELD_LIMIT,
      disabled: isDisabled,
      rows: 1,
      onKeyDown: function onKeyDown(e) {
        if (e.key === 'Enter') {
          e.stopPropagation();
        }
      }
    })]
  });
};